import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { CTAButton } from "@/components/common/CTA";

export default function AboutPreview() {
  return (
    <section className="bg-navy text-white overflow-hidden" data-testid="about-preview">
      <div className="container-page py-20 lg:py-28 grid gap-12 lg:grid-cols-12 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-copper mb-5">
              <span className="h-px w-8 bg-copper" /> About the company
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-bold tracking-tight text-[30px] leading-[36px] md:text-[38px] md:leading-[44px]">
              An international partner for global business
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-[17px] leading-[28px] text-white/70 max-w-xl">
              Premier Global Sourcing supports businesses that need a practical connection between
              product requirements, overseas suppliers and international delivery planning. Our
              international team coordinates trade enquiries involving selected sourcing and
              commercial markets.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8">
              <CTAButton to="/about" variant="primary" icon={ArrowRight} data-testid="about-preview-cta">
                Learn about the company
              </CTAButton>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.1}>
            <div className="relative overflow-hidden rounded-lg border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100"
                alt="Organized warehouse aisle with stacked goods ready for distribution"
                width="1100"
                height="825"
                loading="lazy"
                className="w-full h-[320px] lg:h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 grid grid-cols-3 gap-3">
                {["Requirement-first", "Multi-market", "Coordinated"].map((t) => (
                  <div key={t} className="rounded-md border border-white/15 bg-white/5 backdrop-blur px-3 py-2.5 text-center">
                    <span className="text-[12px] font-medium text-white/90">{t}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
